import { render, staticRenderFns } from "./hospital-terms-of-use.vue?vue&type=template&id=251f0ee3&scoped=true"
import script from "./hospital-terms-of-use.vue?vue&type=script&lang=ts"
export * from "./hospital-terms-of-use.vue?vue&type=script&lang=ts"
import style0 from "./hospital-terms-of-use.vue?vue&type=style&index=0&id=251f0ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f0ee3",
  null
  
)

export default component.exports